import React from "react";
import { GoalStatementList } from "../../components/_dashboard/goalStatement";
import GoalStatementQuestions from "../GoalStatementQuestions";

function GoalStatement(props) {
  return <GoalStatementQuestions />;
}

export default GoalStatement;
